import * as React from 'react';
import { Col, Row, Table } from 'reactstrap';
import { APIError } from '../../APIError';
import ErrorJumbotron from '../../widgets/ErrorJumbotron';
import LoadingIndicator from '../../widgets/LoadingIndicator';
import Panel from '../../widgets/Panel';
import ScaledBytes from '../../widgets/ScaledBytes';
import WorldMap, { CountryInfo } from '../../widgets/WorldMap';

export type TopCountriesEntry = {
  name: string;
  code: string;
  bytes_in: number;
  bytes_out: number;
  flows_in: number;
  flows_out: number;
};

type MapProps = {
  topCountries: Array<TopCountriesEntry>;
  isLoading: boolean;
  error: APIError | null;
};

const NUM_TOP_COUNTRIES = 5;

export default class TopCountriesMap extends React.PureComponent<MapProps> {
  render() {
    const { isLoading, error } = this.props;
    const topCountries = this.props.topCountries || [];

    let countryInfo: { [key: string]: CountryInfo } = {};
    if (!isLoading) {
      topCountries.slice(0, NUM_TOP_COUNTRIES).forEach((row) => {
        countryInfo[row.code] = { color: '#23618E' };
      });
    }
    return (
      <Panel className="d-flex flex-column top-countries-panel">
        <h2 className="mb-4">Top Countries</h2>
        <Row>
          <Col xs={12} md={6} className="mb-0">
            {isLoading && (
              <LoadingIndicator size="lg" centered key="indicator">
                Loading chart data...
              </LoadingIndicator>
            )}
            <Table size="sm" className="mb-0">
              <thead>
                <tr>
                  <th className="text-left">Country</th>
                  <th className="text-right">Bytes In</th>
                  <th className="text-right">Bytes Out</th>
                  <th className="text-right">Flows In</th>
                  <th className="text-right">Flows Out</th>
                </tr>
              </thead>
              <tbody>
                {topCountries.slice(0, NUM_TOP_COUNTRIES).map((row, index) => {
                  return (
                    <tr key={index}>
                      <td className="text-left">{row.name}</td>
                      <td className="text-right">
                        {<ScaledBytes bytes={row.bytes_in} decimals={0} />}
                      </td>
                      <td className="text-right">
                        {<ScaledBytes bytes={row.bytes_out} decimals={0} />}
                      </td>
                      <td className="text-right">{row.flows_in}</td>
                      <td className="text-right">{row.flows_out}</td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
            {error && (
              <ErrorJumbotron className="vertical-center" error={error} />
            )}
          </Col>
          <Col
            xs={12}
            md={6}
            className="d-flex justify-content-center top-countries-map mb-0"
          >
            <WorldMap
              className="world-map-container"
              countryInfo={countryInfo}
            />
          </Col>
        </Row>
      </Panel>
    );
  }
}
